/**
 * HeaderSort is a batchGeoTable plugin that lets you sort the table by the
 * table headers. For example, if you were to click on a column that said
 * "ranking" and the data was [2,5,10,1] it would get sorted to [1,2,5,10] and
 * if you clicked it again it would reverse to [10,5,2,1].
 *
 * HeaderSort tries to be smart on number sorting by removing all characters in
 * columns that look like numbers and then sorting that way. Say you have a
 * column with `5,000.12%`. Even tho that's a string, HeaderSort will sort the
 * column by converting it internally to `5000.12`.
 *
 * There is no public API or any setup aside from adding it to your plugins
 * option array on BatchGeoTable
 */
(function () {
  var HeaderSort = function () {
    var self = this;
    var appState = BatchGeoStore.getState().App;

    // Handles doing sorts on the data
    var sortWorker = new XssSafeWorker(appState.tableSortWorkerUrl);
    // Store past search orders to speed up subsequent sorts
    var sortOrderCache = {};

    var getState = function () {
      return BatchGeoStore.getState().HeaderSort;
    };

    var getData = function () {
      return self.data.rows;
    };

    sortWorker.onmessage = function (message) {
      if (!message.data.order) return;
      var index = message.data.index,
        state = message.data.state;

      // Set the order in our cache object
      _.setWith(
        sortOrderCache,
        [index, state],
        Object.assign({}, message.data.order),
        Object,
      );

      // Still probably need to move this out of the sorting plugin
      // If the RowSelect plugin is enabled, we'll sort it a little
      // bit differently. This is not directly into the sorting algo
      // because that component has no concept of "state" or modules.
      // It just sorts stuff.
      //
      // I didn't put it in the BatchGeoTableMap code that normally
      // acts as the the glue to the table + map because it would
      // require two table view updates for every sort (first sorting
      // in general, then plucking out selected items and putting
      // up top)
      //
      // So I put it in the header sort code after it gets the sorted
      // data but before it updates the table. This is less than
      // optimal because it makes the HeaderSort plugin require
      // knowledge of RowSelect. You, reading this, refactor if you
      // know a better solution.
      var totalLineCount = Object.keys(message.data.order).length;
      _.get(BatchGeoStore.getState(), "RowSelect.selection", []).forEach(
        function (id) {
          // We subtract the total row count from the order, this will
          // keep the order but guarantee each selected row is negative
          // and thus will appear first
          message.data.order[id] -= totalLineCount;
        },
      );

      // Check to make sure we're still sorting by this state and index
      // since this is async and additional workers may be been dispatched
      // since this one
      var currentState = getState();
      if (currentState.index === index && currentState.state === state) {
        BatchGeoStore.dispatch({
          type: "HEADER_SORT_SET_ORDER",
          order: message.data.order,
        });
        // Scroll to the top, we don't use self.scrollToRow as it will
        // unnecessarily iterate over the data
        var onRowsBuilt = self.addListener("rowsbuilt", function () {
          self.removeListener("rowsbuilt", onRowsBuilt);
          $(self.getElements().scrollArea).scrollTop(0);
        });
      }
    };

    // We use this to cache the initial data in order to make sure we
    // determine sort order for all rows regardless of whether they are
    // filtered or not

    var els = self.getElements();
    var $tableHeaders = $(els.fauxHeaderContainer).find("th");
    $tableHeaders.append('<span class="sort-arrow"></span>');

    var updateColumnArrows = function (index, state) {
      $tableHeaders.find(".sort-arrow").html("");
      if (index >= 0) {
        var $arrow = $tableHeaders.find(".sort-arrow").eq(index);
        var arrowIcons = ["&#9650;", "&#9660;"];
        $arrow.html(arrowIcons[state]);
      }
    };

    // Update $tableHeaders each time they render
    self.addListener("builtheaders", function () {
      $tableHeaders = $(els.fauxHeaderContainer).find("th");
      $tableHeaders.append('<span class="sort-arrow"></span>');
      // If the headers were rendered and we're still sorting, reapply
      // the arrows
      var currentState = getState();
      if (currentState.index >= 0) {
        updateColumnArrows(currentState.index, currentState.state);
      }
    });

    // We listen for changes to column data as this will effect sort order
    self.addListener("updatedcolumn", function (index) {
      delete sortOrderCache[index];
      var currentState = getState();
      // If the column updated is the currently sorted column we need to
      // trigger a resort immediately
      if (index === currentState.index) {
        sortWorker.postMessage([
          {
            dataToSort: getData(),
            sortByIndex: currentState.index,
            sortByState: currentState.state,
          },
        ]);
      }
    });
    /**
     * Dispatches next sort index and state
     */
    $(self.container)
      .find("thead")
      .on("click", "th", function () {
        var $th = $(this);
        var currentState = getState();
        var nextIndex = $th.data("position");
        var nextState =
          (nextIndex === currentState.index ? currentState.state : -1) + 1;

        // Above 1 we reset to the default sort order
        if (nextState > 1) {
          nextIndex = -1;
          nextState = 0;
        }

        BatchGeoStore.dispatch({
          type: "HEADER_SORT_SET",
          state: nextState,
          index: nextIndex,
        });
      });

    // A BatchGeo Store listener that triggers sorting workers on index/sort
    // changes
    BatchGeoStore.addListener(
      "HeaderSort",
      function (nextState, prevState) {
        return (
          nextState.index !== prevState.index ||
          nextState.state !== prevState.state
        );
      },
      function (newState) {
        // Try and retrieve the sort order if it's already been calculated
        var orderCache = _.get(sortOrderCache, [
          newState.index,
          newState.state,
        ]);
        // Check if we've already sorted this column
        if (orderCache) {
          sortWorker.onmessage.call(this, {
            data: {
              order: orderCache,
              state: newState.state,
              index: newState.index,
            },
          });
        } else {
          sortWorker.postMessage([
            {
              dataToSort: getData(),
              sortByIndex: newState.index,
              sortByState: newState.state,
            },
          ]);
        }
      },
    );

    // A BatchGeo Store listener that listens for changes to the state
    // property and when there's a change it updates the table header and the
    // arrow in the table heads
    BatchGeoStore.addListener(
      "HeaderSort",
      function (nextState, prevState) {
        return !_.eq(nextState.order, prevState.order);
      },
      function (newState) {
        // Update active column arrow
        updateColumnArrows(newState.index, newState.state);
        // Trigger table to rebuild rows
        self.rebuildRows();
      },
    );
  };

  window.HeaderSort = HeaderSort;
})(window);
